import { mainApi } from '@shared/api'

export const { getMeal, updateMeal, deleteMeal } = mainApi
